var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "showVersions",
      attrs: { id: `version${_vm.pickedVariant}` },
      on: { change: _vm.changeVersionHandler },
    },
    [
      _c("div", { staticClass: "select" }, [
        _c("div", { attrs: { id: "versionBox" } }, [
          _c("strong", [_vm._v("Version:")]),
          _c(
            "select",
            _vm._l(_vm.opts, function (opt) {
              return _c("option", { domProps: { value: opt } }, [
                _vm._v(" " + _vm._s(opt) + " "),
              ])
            }),
            0
          ),
        ]),
        _c("div", [
          _c("button", [
            _c("a", { attrs: { href: _vm.backurlhref, target: "_blank" } }, [
              _vm._v("Back Image"),
            ]),
          ]),
          _c("button", [
            _c("a", { attrs: { href: _vm.fronturlhref, target: "_blank" } }, [
              _vm._v("Front Image"),
            ]),
          ]),
          _c("button", [
            _c("a", { attrs: { href: _vm.pdfurlhref, target: "_blank" } }, [
              _vm._v("PDF"),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "comments" }, [
        _c("p", [
          _c("strong", [_vm._v("SKU:")]),
          _vm._v(" " + _vm._s(_vm.productSku)),
        ]),
        _c("p", [
          _c("strong", [_vm._v("EAN:")]),
          _vm._v(" " + _vm._s(_vm.productEAN)),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Global Product ID:")]),
          _vm._v(" " + _vm._s(_vm.productID)),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Comments:")]),
          _vm._v(" " + _vm._s(_vm.versionComments)),
        ]),
      ]),
      _c("div", { staticClass: "dates" }, [
        _c("div", { staticClass: "date_ele" }, [
          _c("strong", [_vm._v("Created :")]),
          _c("p", [_vm._v(_vm._s(_vm.created))]),
        ]),
        _c("div", { staticClass: "date_ele" }, [
          _c("strong", [_vm._v("Updated :")]),
          _c("p", [_vm._v(_vm._s(_vm.updated))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }